import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { getPublishedAppVersionKey } from './appVersion.keys';
import { getPublishedAppVersion } from './appVersion.repository';
import { AppVersionOutput } from './appVersion.types';

export const usePublishedAppVersion = (options?: UseDataQueryOptions<AppVersionOutput>) =>
  useDataQuery<AppVersionOutput>(
    {
      queryKey: getPublishedAppVersionKey(),
      queryFn: getPublishedAppVersion,
    },
    options,
  );
